import type { Route, RouteConfig } from 'vue-router'
import { isAuthorized, lazyLoadView, piloteAndAuditor } from '@/router/routing'
import { PERIMETERS_ROUTE_NAME } from '@/contexts/perimeters/Perimeters.constants'

export const perimetersRoutes: RouteConfig = {
  path: '/perimeters',
  name: PERIMETERS_ROUTE_NAME,
  component: () => lazyLoadView(import('@/contexts/perimeters/PerimetersView.vue')),
  meta: {
    i18nTitle: 'perimeters.menu.title',
    icon: 'layer-group',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    doc_id: 'perimeters',
  },
  children: [],
}
